
angular.module('theme.core.filters')

.filter('trust', function($sce) {
  return function(value, type) {
    return $sce.trustAs(type || 'html', value);
  }
})